const PreviousButtonIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M7.80669 9.00024L10.8464 12.0399C10.944 12.1375 10.994 12.257 10.9964 12.3983C10.9988 12.5397 10.9488 12.6635 10.8464 12.7697C10.744 12.876 10.6223 12.9306 10.4815 12.9338C10.3406 12.9369 10.2171 12.8841 10.1108 12.7755L6.78558 9.45024C6.71923 9.38629 6.67068 9.31694 6.63991 9.24219C6.60914 9.16743 6.59375 9.08678 6.59375 9.00024C6.59375 8.91371 6.60914 8.83306 6.63991 8.7583C6.67068 8.68355 6.71923 8.613 6.78558 8.54665L10.1108 5.22141C10.2123 5.11997 10.3346 5.06961 10.4779 5.07032C10.6211 5.07104 10.744 5.12453 10.8464 5.23078C10.9488 5.33703 11 5.45963 11 5.59856C11 5.7375 10.9488 5.85817 10.8464 5.96057L7.80669 9.00024Z"
        fill="#999999"
      />
    </svg>
  );
};

export default PreviousButtonIcon;
